import { useQuery } from "@apollo/client";
import React, { useState } from "react";
import { LISTAR_SUBTIPO_EGRESOS } from "../../../graphql/bancos";
import Scrollbar from "../../../components/Scrollbar";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TablePagination,
  TableRow,
} from "@mui/material";
import { OBTENER_CAT_EGRESOS } from "../../../graphql/egresos";
import MovimientosHeader from "../../../components/TableHeader/MovimientosHeader";
import Iconify from "../../../components/Iconify";
const TABLE_HEADER = [
  { id: "clave", label: "Clave", alignRight: false },
  { id: "descripcion", label: "Descripción", alignRight: false },
  { id: "", label: "", alignRight: false },
];

const CatalogoEgresosTable = () => {
  const { data, loading, error } = useQuery(OBTENER_CAT_EGRESOS);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  if (loading) {
    return <h1>Cargando informacio´n...</h1>;
  }

  const { obtenerCategoriasEgresos } = data;
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleEditData = (e) => {
    // setBodyDialog(
    //   <FrmEditarConceptosBanco
    //     setOpenDialog={setOpenDialog}
    //     setErrorGraph={setErrorGraph}
    //     setOpenSnackBar={setOpenSnackBar}
    //     id={e}
    //   />
    // );
    // setOpenDialog(true);
  };

  return (
    <>
      <Scrollbar>
        <Table>
          <MovimientosHeader headLabel={TABLE_HEADER} />
          <TableBody>
            {obtenerCategoriasEgresos
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => {
                const { id, clave, descripcion } = row;
                return (
                  <TableRow hover key={id} tabIndex={-1}>
                    <TableCell>{clave}</TableCell>
                    <TableCell>{descripcion}</TableCell>
                    <TableCell>
                      {/* <Button
                        value={id}
                        onClick={(e) => {
                          handleEditData(id);
                        }}
                        startIcon={<Iconify icon="eva:edit-2-outline" />}
                      >
                        Editar
                      </Button> */}
                      {/* {baja ? (
                       <>
                         <Button
                           color="primary"
                           value={id}
                           startIcon={<Iconify icon="eva:checkmark-outline" />}
                           onClick={(e) => {
                            // handleActiveteRecord(id);
                           }}
                         >
                           Activar
                         </Button>
                         <Button
                           value={id}
                           onClick={(e) => {
                           //  handleDeleteRecord(id);
                           }}
                           color="error"
                           startIcon={<Iconify icon="eva:close-outline" />}
                         >
                           Eliminar
                         </Button>
                       </>
                     ) : (
                       <Button
                         value={id}
                         onClick={(e) => {
                          // handleDeactivateRecord(id);
                         }}
                         color="error"
                         startIcon={<Iconify icon="eva:close-outline" />}
                       >
                         Desactivar
                       </Button>
                     )} */}
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </Scrollbar>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        page={page}
        count={obtenerCategoriasEgresos.length}
        rowsPerPage={rowsPerPage}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );
};

export default CatalogoEgresosTable;
